import React from "react";
import { todayYYYYMMDD } from "../../../../core";
import { createUseStyles } from "react-jss";

const useStyles = createUseStyles((theme) => ({
  loading: {
    height: "80vh",
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
  },
  date: {
    textAlign: "center",
    margin: [12, 0],
    color: theme.dateColor,
    fontSize: theme.messageFontSizeontSize,
  },
}));
const Today = (props) => {
  const { chats } = props;
  const styles = useStyles();
  return (
    <>
      {!chats ? (
        <p className={styles.date}>امروز</p>
      ) : (
        !Object.keys(chats).includes(todayYYYYMMDD()) && (
          <p className={styles.date}>امروز</p>
        )
      )}
    </>
  );
};

export default Today;
